import { Typography, TypographyProps } from "@mui/material";
import React from "react";

export const CustomTypography: React.FC<TypographyProps> = ({
  children,
  sx,
  ...rest
}) => {
  return (
    <Typography
      {...rest}
      sx={{
        fontFamily: "Inter, sans-serif",
        color: "#1A1A1A",
        ...sx,
      }}
    >
      {children}
    </Typography>
  );
};
